var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46952 12.4697L5.46951 12.4698C5.39984 12.5394 5.34457 12.6221 5.30687 12.7132C5.26916 12.8042 5.24976 12.9018 5.24976 13.0003C5.24976 13.0988 5.26916 13.1964 5.30687 13.2874C5.34457 13.3784 5.39984 13.4611 5.46951 13.5308C5.53918 13.6005 5.62189 13.6557 5.71291 13.6934C5.80394 13.7311 5.90151 13.7506 6.00003 13.7506C6.09856 13.7506 6.19613 13.7311 6.28715 13.6934C6.37818 13.6557 6.46089 13.6005 6.53056 13.5308L11.5305 8.5309C11.5305 8.53087 11.5305 8.53084 11.5306 8.53081C11.6002 8.46117 11.6555 8.37849 11.6933 8.28748C11.731 8.19643 11.7504 8.09884 11.7504 8.00028C11.7504 7.90172 11.731 7.80412 11.6933 7.71307C11.6555 7.62207 11.6002 7.53939 11.5306 7.46975C11.5305 7.46972 11.5305 7.46969 11.5305 7.46965L6.53056 2.46975C6.38986 2.32905 6.19902 2.25 6.00003 2.25C5.80105 2.25 5.61021 2.32905 5.46951 2.46975C5.3288 2.61046 5.24976 2.80129 5.24976 3.00028C5.24976 3.19926 5.3288 3.3901 5.46951 3.5308L5.46952 3.53082L9.93958 8.00028L5.46952 12.4697Z",
    fill: "#FF7A2A",
    stroke: "#FF7A2A",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/CaretRight.028497aaba84151adef245d524e05908.svg";
export { ForwardRef as ReactComponent };